(() => {
  const config = document.getElementById('WallifyWishlistConfig');
  if (!config) return;
  const labels = config.dataset;
  const key = 'wallify_favorites_v1';
  const selectionsKey = 'wallify_favorite_selections_v1';
  let selections = {};
  const root = labels.root.replace(/\/$/, '') + '/';
  const dialog = document.getElementById('WallifyWishlistDrawer');
  let items = [];
  let statusTimer;
  let cartBusy = false;
  const cache = new Map();
  const versions = new WeakMap();
  const status = (text) => {
    const node = document.querySelector('[data-wishlist-status]');
    if (!node) return;
    node.textContent = text;
    clearTimeout(statusTimer);
    statusTimer = setTimeout(() => { node.textContent = ''; }, 4500);
  };
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(v => typeof v === 'string' && /^[a-z0-9-]+$/.test(v)))].slice(0, 200) : [];
    } catch { return []; }
  };
  const readSelections = () => {
    try {
      const value = JSON.parse(localStorage.getItem(selectionsKey) || '{}');
      if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
      return Object.fromEntries(Object.entries(value).filter(([handle, entry]) =>
        items.includes(handle) && entry && typeof entry === 'object'
      ).slice(0, 200).map(([handle, entry]) => [handle, {
        variant: typeof entry.variant === 'string' && /^\d+$/.test(entry.variant) ? entry.variant : '',
        premium: entry.premium === true,
        options: Array.isArray(entry.options) ? entry.options.slice(0, 3).map(value => typeof value === 'string' ? value.slice(0, 200) : '') : []
      }]));
    } catch { return {}; }
  };
  const saveSelection = (handle, selection) => {
    if (!items.includes(handle)) return;
    selections[handle] = selection;
    try { localStorage.setItem(selectionsKey, JSON.stringify(selections)); }
    catch { status(labels.storage); }
  };
  const rememberCard = card => {
    const master = card.querySelector('[data-wishlist-variant]');
    if (!master) return;
    const choices = [...card.querySelectorAll('[data-wishlist-choice]')];
    const selected = master.selectedOptions[0];
    saveSelection(card.dataset.wishlistCard, {
      variant: master.value || '',
      premium: card.dataset.premiumSelected === 'true',
      options: choices.length ? choices.map(select => select.value) : [1, 2, 3].map(i => selected?.dataset['o' + i]).filter(value => value !== undefined)
    });
  };
  const restoreCard = card => {
    const master = card.querySelector('[data-wishlist-variant]');
    const saved = selections[card.dataset.wishlistCard];
    if (!master || !saved) return [];
    const variants = [...master.options].filter(option => option.value && !option.disabled);
    let match = variants.find(option => option.value === saved.variant || option.dataset.premiumId === saved.variant);
    card.dataset.premiumSelected = String(saved.premium || Boolean(match?.dataset.premiumId === saved.variant));
    if (!match && saved.options.length && saved.options.every(Boolean)) {
      match = variants.find(option => saved.options.every((value, index) => option.dataset['o' + (index + 1)] === value));
    }
    if (match) {
      master.value = match.value;
      return [1, 2, 3].filter(i => match.dataset['o' + i] !== undefined).map(i => [String(i), match.dataset['o' + i]]);
    }
    if (saved.variant) {
      master.value = '';
      const message = card.querySelector('[data-wishlist-selection-status]');
      if (message) { message.hidden = false; message.textContent = labels.selectionUnavailable; }
      return [];
    }
    return saved.options.map((value, index) => [String(index + 1), value]);
  };
  const wishlistControls = '[data-wallify-favorite], [data-wishlist-count], [data-wishlist-open], .wallify-wishlist-header';
  const wishlistChrome = '[data-wishlist-count], [data-wishlist-open], .wallify-wishlist-header';
  const setAttributeIfChanged = (node, name, value) => {
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  };
  const syncWishlistControl = node => {
    if (node.matches('[data-wallify-favorite]')) {
      const saved = items.includes(node.dataset.wallifyFavorite);
      const text = saved ? labels.remove : labels.add;
      setAttributeIfChanged(node, 'aria-pressed', String(saved));
      setAttributeIfChanged(node, 'aria-label', text);
      const label = node.querySelector('[data-favorite-label]');
      if (label && label.textContent !== text) label.textContent = text;
    }
    if (node.matches('[data-wishlist-count]')) {
      if (node.textContent !== String(items.length)) node.textContent = items.length;
      if (node.hidden !== !items.length) node.hidden = !items.length;
    }
    if (node.matches('[data-wishlist-open], .wallify-wishlist-header')) {
      if (!node.dataset.wishlistBaseLabel) node.dataset.wishlistBaseLabel = node.getAttribute('aria-label') || labels.title;
      setAttributeIfChanged(node, 'aria-label', node.dataset.wishlistBaseLabel + (items.length ? ', ' + (items.length === 1 ? labels.savedOne || labels.savedCount : labels.savedCount).replace('{count}', items.length) : ''));
    }
  };
  const syncButtons = () => document.querySelectorAll(wishlistControls).forEach(syncWishlistControl);
  const fetchCard = async handle => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const fetchSection = path => fetch(path, {credentials:'same-origin',cache:'no-store',signal:controller.signal});
      let response = await fetchSection(root + 'products/' + encodeURIComponent(handle) + '?section_id=wallify-wishlist-card');
      if (!response.ok) throw new Error('Unavailable');
      let doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      let card = doc.querySelector('[data-wishlist-card]');
      if (!card) {
        const redirected = new URL(response.url);
        if (redirected.origin === location.origin && redirected.pathname.includes('/products/') && !redirected.searchParams.has('section_id')) {
          redirected.searchParams.set('section_id','wallify-wishlist-card');
          response = await fetchSection(redirected.href);
          if (response.ok) {
            doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            card = doc.querySelector('[data-wishlist-card]');
          }
        }
      }
      if (!card) throw new Error('Unavailable');
      card.dataset.wishlistCard = handle;
      card.querySelectorAll('[data-wallify-favorite]').forEach(b => { b.dataset.wallifyFavorite = handle; });
      return card;
    } finally { clearTimeout(timeout); }
  };
  const cardFor = async handle => {
    if (!cache.has(handle)) {
      cache.set(handle, fetchCard(handle).catch(() => fetchCard(handle)).catch(error => { cache.delete(handle); throw error; }));
    }
    return (await cache.get(handle)).cloneNode(true);
  };
  const selectedVariant = card => {
    const master = card.querySelector('[data-wishlist-variant]');
    const option = master?.value && !master.selectedOptions[0]?.disabled ? master.selectedOptions[0] : null;
    if (!option) return null;
    const premium = card.dataset.premiumSelected === 'true' && Boolean(option.dataset.premiumId);
    return {id: premium ? option.dataset.premiumId : option.value,
      price: Number(premium ? option.dataset.premiumPrice : option.dataset.price),
      formatted: premium ? option.dataset.premiumFormatted : option.dataset.formatted};
  };
  const updateTotal = () => {
    const page = document.querySelector('.wallify-wishlist-page');
    if (!page) return;
    const selections = [...page.querySelectorAll('[data-wishlist-variant]')].filter(select => select.value && !select.selectedOptions[0]?.disabled);
    const total = selections.reduce((sum, select) => sum + (selectedVariant(select.closest('[data-wishlist-card]'))?.price || 0), 0);
    const currency = window.Shopify?.currency?.active;
    let formatted = '';
    try { if (currency) formatted = new Intl.NumberFormat(document.documentElement.lang, {style:'currency', currency}).format(total / 100); } catch {}
    const countNode = page.querySelector('[data-wishlist-total]');
    countNode.textContent = (selections.length === 1 ? countNode.dataset.one : countNode.dataset.many).replace('{count}', selections.length);
    page.querySelector('[data-wishlist-total-price]').textContent = formatted;
    page.querySelector('[data-wishlist-add-all]').disabled = !selections.length || cartBusy;
  };
  const populate = async (list) => {
    const version = (versions.get(list) || 0) + 1;
    versions.set(list, version);
    list.replaceChildren();
    list.setAttribute('aria-busy', 'true');
    list.dataset.itemCount = String(items.length);
    const empty = list.parentElement.querySelector('[data-wishlist-empty]');
    if (empty) empty.hidden = items.length > 0;
    const summary = list.closest('.wallify-wishlist-page')?.querySelector('.wallify-wishlist-summary');
    if (summary) summary.hidden = !items.length;
    const handles = [...items].reverse();
    const slots = handles.map(handle => {
      const slot = document.createElement('div');
      slot.textContent = labels.loading;
      list.append(slot);
      return {handle, slot};
    });
    let index = 0;
    const worker = async () => {
      while (index < slots.length) {
        const {handle, slot} = slots[index++];
        try {
          const card = await cardFor(handle);
          if (versions.get(list) !== version) return;
          const savedChoices = restoreCard(card);
          if (list.dataset.wishlistMode === 'page') initChoices(card, savedChoices);
          updateVariant(card);
          slot.replaceWith(card);
          updateTotal();
        } catch {
          if (versions.get(list) !== version) return;
          slot.className = 'wallify-wishlist-unavailable';
          const message = document.createElement('p');
          message.textContent = labels.unavailable;
          const actions = document.createElement('div');
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.dataset.wishlistRetry = handle;
          retry.className = 'wallify-wishlist-retry';
          retry.textContent = labels.retry;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.wallifyFavorite = handle;
          remove.className = 'wallify-wishlist-remove-unavailable';
          remove.textContent = labels.remove;
          actions.append(retry,remove);
          slot.replaceChildren(message, actions);
        }
        syncButtons();
        updateTotal();
      }
    };
    await Promise.all([worker(), worker(), worker(), worker()]);
    if (versions.get(list) !== version) return;
    list.setAttribute('aria-busy', 'false');
    syncButtons();
    updateTotal();
  };
  const render = () => {
    syncButtons();
    document.querySelectorAll('[data-wishlist-list]').forEach(list => {
      if (list.dataset.wishlistMode === 'page' || dialog.open) populate(list);
    });
  };
  const initChoices = (card, savedChoices = []) => {
    const box = card.querySelector('[data-wishlist-choices]');
    const master = card.querySelector('[data-wishlist-variant]');
    if (!box || !master) return;
    const variants = [...master.options].filter(o => o.value);
    const dimensions = [1,2,3].filter(i => variants.some(o => o.dataset['o'+i]));
    const chosen = master.value ? master.selectedOptions[0] : null;
    const saved = new Map(savedChoices);
    box.replaceChildren();
    dimensions.forEach((i, index) => {
      const label = document.createElement('label');
      label.textContent = box.dataset['optionLabel' + i] || labels.choose;
      const select = document.createElement('select');
      select.dataset.wishlistChoice = i;
      select.setAttribute('aria-label', label.textContent);
      label.append(select);box.append(label);
    });
    const rebuild = (changed = 0) => {
      const selectors = [...box.querySelectorAll('select')];
      selectors.forEach((select,index) => {
        const previous = selectors.slice(0,index);
        const candidates = variants.filter(o => !o.disabled && previous.every(s => s.value && o.dataset['o'+s.dataset.wishlistChoice] === s.value));
        const position = select.dataset.wishlistChoice;
        const old = select.value || (changed === 0 ? saved.get(position) || chosen?.dataset['o'+position] : '');
        const values = new Map(candidates.map(o => [o.dataset['o'+position],o.dataset['l'+position] || o.dataset['o'+position]]));
        const placeholder = new Option(box.dataset.choose,'');
        placeholder.disabled = true;
        placeholder.hidden = true;
        select.replaceChildren(placeholder);
        values.forEach((text,value) => select.add(new Option(text.trim(),value)));
        select.value = '';
        select.disabled = index > 0 && previous.some(s => !s.value);
        if (values.has(old) && (!changed || index < changed)) select.value = old;
        else if (values.size === 1) select.value = [...values.keys()][0];
        select.closest('label').hidden = values.size === 1 && [...values.keys()][0]?.toLowerCase() === 'no frame';
        select.title = select.selectedOptions[0]?.text || '';
      });
      const match = variants.find(o => !o.disabled && selectors.every(s => s.value && o.dataset['o'+s.dataset.wishlistChoice] === s.value));
      master.value = match?.value || '';
      updateVariant(card);updateTotal();
    };
    box.addEventListener('change', event => {
      const index = dimensions.indexOf(Number(event.target.dataset.wishlistChoice));
      card.querySelector('[data-wishlist-selection-status]')?.setAttribute('hidden', '');
      rebuild(index + 1);
      rememberCard(card);
      document.querySelectorAll('[data-wishlist-card]').forEach(other => {
        if (other !== card && other.dataset.wishlistCard === card.dataset.wishlistCard) { restoreCard(other); updateVariant(other); }
      });
    });
    rebuild();
  };
  const updateVariant = card => {
    const price = card.querySelector('[data-wishlist-price]');
    if (price && !price.dataset.initial) price.dataset.initial = price.textContent;
    const select = card.querySelector('[data-wishlist-variant]');
    const selected = select?.value && !select.selectedOptions[0]?.disabled ? select.selectedOptions[0] : null;
    const button = card.querySelector('[data-wishlist-add]');
    if (button) button.disabled = !selected || cartBusy;
    const quality = card.querySelector('[data-wishlist-quality]');
    if (quality) {
      const premiumOption = quality.querySelector('[value="premium"]');
      premiumOption.disabled = !selected?.dataset.premiumId;
      card.querySelector('[data-wishlist-quality-label]').hidden = !selected?.dataset.framed;
      if (!selected?.dataset.premiumId) card.dataset.premiumSelected = 'false';
      quality.value = card.dataset.premiumSelected === 'true' ? 'premium' : 'standard';
    }
    const effective = selectedVariant(card);
    const personalConfig = card.querySelector('[data-wishlist-personal-variants]');
    const savedPersonal = personalConfig && selections[card.dataset.wishlistCard];
    const selectedPersonal = savedPersonal && JSON.parse(personalConfig.textContent).find(v => String(v.id) === savedPersonal.variant && v.available);
    if (price) price.textContent = effective ? effective.formatted : selectedPersonal?.money || price.dataset.initial;
    card.querySelectorAll('[data-wishlist-product-link]').forEach(link => {
      if (!link.dataset.baseHref) link.dataset.baseHref = link.getAttribute('href');
      const url = new URL(link.dataset.baseHref, location.origin);
      if (selected) url.searchParams.set('variant', selected.value);
      else if (selectedPersonal) url.searchParams.set('variant', String(selectedPersonal.id));
      if (card.dataset.premiumSelected === 'true') url.searchParams.set('frame_upgrade', 'premium');
      else url.searchParams.delete('frame_upgrade');
      link.href = url.href;
    });
    const image = card.querySelector('[data-wishlist-image] img');
    if (image) {
      if (!image.dataset.initialSrc) {
        image.dataset.initialSrc = image.getAttribute('src');
        image.dataset.initialSrcset = image.getAttribute('srcset') || '';
      }
      image.src = selected?.dataset.image || image.dataset.initialSrc;
      if (selected?.dataset.image) image.removeAttribute('srcset');
      else if (image.dataset.initialSrcset) image.setAttribute('srcset', image.dataset.initialSrcset);
    }
    const frame = card.querySelector('[data-wishlist-frame]');
    const showFrame = Boolean(frame && selected?.dataset.frame);
    if (frame) {
      frame.hidden = !showFrame;
      const preview = frame.querySelector('wallify-frame-preview');
      if (showFrame && preview) {
        preview.dataset.frame = selected.dataset.frame;
        preview.setAttribute('aria-label', card.querySelector('.wallify-wishlist-card__title').textContent.trim() + ', ' + selected.dataset.summary);
      }
    }
    const originalImage = card.querySelector('[data-wishlist-image]');
    if (originalImage) originalImage.hidden = showFrame;
    const summary = card.querySelector('[data-wishlist-config-summary]');
    if (summary && personalConfig) {
      summary.hidden = !selectedPersonal;
      summary.textContent = selectedPersonal?.summary || '';
      return;
    }
    if (summary) {
      summary.hidden = !selected?.dataset.summary;
      summary.textContent = (selected?.dataset.summary || '') + (selected?.dataset.framed && quality ? ' · ' + quality.selectedOptions[0].textContent.trim() : '');
    }
  };
  const addToCart = async (cartItems) => {
    if (cartBusy || !cartItems.length) return;
    cartBusy = true;
    document.querySelectorAll('[data-wishlist-add]').forEach(button => { button.disabled = true; });
    updateTotal();
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, credentials:'same-origin', body:JSON.stringify({items:cartItems})});
      if (!response.ok) throw new Error('Cart error');
      window.location.assign(root + 'cart');
    } catch { status(labels.error); }
    finally {
      cartBusy = false;
      document.querySelectorAll('[data-wishlist-card]').forEach(updateVariant);
      updateTotal();
    }
  };
  document.addEventListener('click', event => {
    const viewLink = event.target.closest('[data-wishlist-view]');
    if (viewLink) {
      event.preventDefault();
      window.location.assign(viewLink.href);
      return;
    }
    const retry = event.target.closest('[data-wishlist-retry]');
    if (retry) { cache.delete(retry.dataset.wishlistRetry); populate(retry.closest('[data-wishlist-list]')); return; }
    const favorite = event.target.closest('[data-wallify-favorite]');
    if (favorite) {
      event.preventDefault();
      const handle = favorite.dataset.wallifyFavorite;
      const next = items.includes(handle) ? items.filter(item => item !== handle) : [...items, handle];
      try { localStorage.setItem(key, JSON.stringify(next)); }
      catch { status(labels.storage); return; }
      items = next;
      if (items.includes(handle)) {
        const product = favorite.closest('.product');
        const variantInput = product?.querySelector('form[action*="/cart/add"] [name="id"]');
        if (variantInput?.value && /^\d+$/.test(variantInput.value)) saveSelection(handle, {variant: variantInput.value, options: []});
      } else {
        delete selections[handle];
        try { localStorage.setItem(selectionsKey, JSON.stringify(selections)); } catch {}
      }
      render();
      return;
    }
    if (event.target.closest('[data-wishlist-open]')) {
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
      cache.clear();
      populate(dialog.querySelector('[data-wishlist-list]'));
    }
    if (event.target.closest('[data-wishlist-close]')) dialog.close();
    const add = event.target.closest('[data-wishlist-add]');
    if (add && !add.disabled) {
      const id = selectedVariant(add.closest('[data-wishlist-card]'))?.id;
      addToCart([{id:Number(id), quantity:1}]);
    }
    if (event.target.closest('[data-wishlist-add-all]')) {
      const selected = [...document.querySelectorAll('.wallify-wishlist-page [data-wishlist-variant]')].filter(select => select.value && !select.selectedOptions[0]?.disabled);
      addToCart(selected.map(select => ({id:Number(selectedVariant(select.closest('[data-wishlist-card]')).id), quantity:1})));
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-wishlist-quality]')) {
      const card = event.target.closest('[data-wishlist-card]');
      card.dataset.premiumSelected = String(event.target.value === 'premium');
      updateVariant(card);
      rememberCard(card);
      document.querySelectorAll('[data-wishlist-card]').forEach(other => {
        if (other !== card && other.dataset.wishlistCard === card.dataset.wishlistCard) { restoreCard(other); updateVariant(other); }
      });
      updateTotal();
      return;
    }
    if (!event.target.matches('[data-wishlist-variant]')) return;
    const card = event.target.closest('[data-wishlist-card]');
    updateVariant(card);
    rememberCard(card);
    updateTotal();
  });
  dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); });
  window.addEventListener('storage', event => { if (event.key === key || event.key === selectionsKey || event.key === null) { items = read(); selections = readSelections(); cache.clear(); render(); } });
  window.addEventListener('pageshow', event => { if (event.persisted) { items = read(); selections = readSelections(); cache.clear(); render(); } });
  const pendingWishlistControls = new Set();
  let syncButtonsFrame = null;
  let refreshWishlistChrome = false;
  const collectWishlistControls = node => {
    if (!(node instanceof Element)) return;
    if (node.matches(wishlistControls)) pendingWishlistControls.add(node);
    node.querySelectorAll(wishlistControls).forEach(control => pendingWishlistControls.add(control));
  };
  const scheduleWishlistSync = records => {
    records.forEach(record => {
      const target = record.target instanceof Element ? record.target : record.target.parentElement;
      const control = target?.closest(wishlistControls);
      if (control) pendingWishlistControls.add(control);
      record.addedNodes.forEach(collectWishlistControls);
      record.removedNodes.forEach(node => {
        if (node instanceof Element && (node.matches(wishlistControls) || node.querySelector(wishlistControls))) {
          refreshWishlistChrome = true;
        }
      });
    });
    if ((!pendingWishlistControls.size && !refreshWishlistChrome) || syncButtonsFrame !== null) return;
    syncButtonsFrame = requestAnimationFrame(() => {
      syncButtonsFrame = null;
      if (refreshWishlistChrome) {
        document.querySelectorAll(wishlistChrome).forEach(control => pendingWishlistControls.add(control));
        refreshWishlistChrome = false;
      }
      const controls = [...pendingWishlistControls];
      pendingWishlistControls.clear();
      controls.forEach(control => {
        if (control.isConnected) syncWishlistControl(control);
      });
    });
  };
  const mainContent = document.getElementById('MainContent');
  if (mainContent) new MutationObserver(scheduleWishlistSync).observe(mainContent, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', syncButtons);
  items = read();
  selections = readSelections();
  render();
})();




